import React from 'react'

type Props = {
  fill?: string
}

const SortIcon = (props: Props) => {
  const { fill='var(--cta-clr-text)' } = props;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.31311 2.31319C4.50838 2.11793 4.82496 2.11793 5.02022 2.31319L7.68689 4.97986C7.88215 5.17512 7.88215 5.49171 7.68689 5.68697C7.49162 5.88223 7.17504 5.88223 6.97978 5.68697L5.16667 3.87385V13.3334C5.16667 13.6096 4.94281 13.8334 4.66667 13.8334C4.39052 13.8334 4.16667 13.6096 4.16667 13.3334V3.87385L2.35355 5.68697C2.15829 5.88223 1.84171 5.88223 1.64645 5.68697C1.45118 5.49171 1.45118 5.17512 1.64645 4.97986L4.31311 2.31319ZM11.3333 2.16675C11.6095 2.16675 11.8333 2.39061 11.8333 2.66675V12.1263L13.6464 10.3132C13.8417 10.1179 14.1583 10.1179 14.3536 10.3132C14.5488 10.5085 14.5488 10.825 14.3536 11.0203L11.6869 13.687C11.4916 13.8822 11.175 13.8822 10.9798 13.687L8.31311 11.0203C8.11785 10.825 8.11785 10.5085 8.31311 10.3132C8.50838 10.1179 8.82496 10.1179 9.02022 10.3132L10.8333 12.1263V2.66675C10.8333 2.39061 11.0572 2.16675 11.3333 2.16675Z" fill="#2B244C"/>
</svg>
  )
}

export default SortIcon